import Master from './Master';
class LiveState {
    constructor() {
        this.tracks = [];
        this.returnTracks = [];
        this.scenes = [];
        this.GlobalQuantization = '1m';
        this.Master = new Master();
    }
    reset() {
        this.tracks = [];
        this.returnTracks = [];
        this.scenes = [];
        this.GlobalQuantization = '1m';
        this.Master = new Master();
    }
    dispose() {
        this.tracks = [];
        this.returnTracks = [];
        this.scenes = [];
        this.GlobalQuantization = '1m';
    }
}
export default new LiveState();
//# sourceMappingURL=LiveState.js.map